// Top level libraries and 3rd party dependencies
import React, { Component } from 'react';
import { func, object } from 'prop-types';

// Redux
import { connect } from 'react-redux';

import { LIMITED_LOGIN_SEND_MESSAGE_TIMER } from '../../constants/ActionTypes';
import {
    forgotPIN,
    getConversationDetails,
    login,
    logout,
    resetForgottenPIN,
    savePIN,
    stopLimitedLoginMessageTimer,
    verifyName,
    verifyDOB,
} from '../../actions/session/sessionActions';

// Layout
import Login from '../Login';
import VerifyContact from './VerifyContact';
import VerifyPatient from './VerifyPatient';


class VerifyContainer extends Component {
    static propTypes = {
        conversationDetails: object.isRequired,
        forgotPIN: func,
        getConversationDetails: func.isRequired,
        history: object,
        loadingState: object,
        location: object,
        login: func.isRequired,
        logout: func,
        match: object,
        savePIN: func.isRequired,
        session: object,
        stopLimitedLoginMessageTimer: func,
        verifyDOB: func.isRequired,
        verifyName: func.isRequired,
    };

    componentDidMount() {
        this.updateConversationDetails();

        // Ensures we dont accidentally have a timer running from an Expired conversation.
        this.props.stopLimitedLoginMessageTimer({ timerName: LIMITED_LOGIN_SEND_MESSAGE_TIMER });

        // Ensures we never have localStorage objects set.
        this.props.logout();
    }

    updateConversationDetails = () => {
        const { conversationHash } = this.props.match.params;

        if (conversationHash) {
            this.props.getConversationDetails(conversationHash);
        }
    };

    render() {
        // We are getting session_hash, i.e., "conversationHash" from the react-router level props
        const { conversationHash } = this.props.match.params;
        const {
            conversationDetails,
            forgotPIN,
            loadingState,
            login,
            resetForgottenPIN,
            savePIN,
            session,
            verifyDOB,
            verifyName,
        } = this.props;

        if (conversationDetails.useNameVerify && !conversationDetails.hasConfirmedPIN) {
            return (
                <VerifyContact
                    conversationDetails={conversationDetails}
                    conversationHash={conversationHash}
                    loadingState={loadingState}
                    savePIN={savePIN}
                    session={session}
                    verifyName={verifyName}
                />
            );
        }
        else if (conversationDetails.hasConfirmedPIN) {
            return (
                <Login
                    conversationHash={conversationHash}
                    forgotPIN={forgotPIN}
                    loadingState={loadingState}
                    login={login}
                    conversationDetails={conversationDetails}
                    resetForgottenPIN={resetForgottenPIN}
                    session={session}
                />
            );
        }
        else if (!conversationDetails.hasConfirmedPIN && conversationDetails.expiredConversation) {
            return (
                <Login
                    conversationHash={conversationHash}
                    forgotPIN={forgotPIN}
                    loadingState={loadingState}
                    login={login}
                    conversationDetails={conversationDetails}
                    resetForgottenPIN={resetForgottenPIN}
                    session={session}
                />
            );
        }
        else {
            return (
                <VerifyPatient
                    conversationHash={conversationHash}
                    loadingState={loadingState}
                    conversationDetails={conversationDetails}
                    savePIN={savePIN}
                    session={session}
                    verifyDOB={verifyDOB}
                />
            );
        }
    }
}

const mapStateToProps = state => ({
    conversationDetails: state.session.conversationDetails,
    loadingState: state.loadingState,
    session: state.session,
});

const mapDispatchToProps = dispatch => ({
    forgotPIN: () => dispatch(forgotPIN()),
    getConversationDetails: conversationId => dispatch(getConversationDetails(conversationId)),
    logout: () => dispatch(logout()),
    resetForgottenPIN: conversationHash => dispatch(resetForgottenPIN(conversationHash)),
    savePIN: request => dispatch(savePIN(request)),
    stopLimitedLoginMessageTimer: request => dispatch(stopLimitedLoginMessageTimer(request)),
    verifyDOB: request => dispatch(verifyDOB(request)),
    verifyName: request => dispatch(verifyName(request)),
    login: request => dispatch(login(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyContainer);
